import React from 'react';
import classnames from 'classnames';
import styles from './devices.css';

import { EnabledIcon, DisabledIcon, DesktopIcon, MobileIcon } from '../icons/icons';
import { Icon } from '../icon';
import Colors from '../colors';

interface Props {
  /** When true, it indicates the content type has a mobile version */
  mobile: boolean;
  /** When true, it indicates the content type has a desktop version */
  desktop: boolean;
  /** Adds additional classes to the component. */
  className?: string;
}

export const Devices = (props: Props) => {
  const { mobile, desktop, className, ...rest } = props;
  const enabledIcon = (
    <Icon color={Colors.Shamrock}>
      <EnabledIcon data-testid="device-enabled" />
    </Icon>
  );
  const disabledIcon = (
    <Icon color={Colors.SilverAlto}>
      <DisabledIcon data-testid="device-disabled" />
    </Icon>
  );
  const devicesClasses = classnames(styles.devices, className);
  return (
    <div className={devicesClasses} {...rest}>
      <div className={styles.wrapper} data-testid="desktop-wrapper">
        <Icon color={Colors.Emperor} className={styles.deviceIcon}>
          <DesktopIcon data-testid="desktop-icon" />
        </Icon>
        {desktop ? enabledIcon : disabledIcon}
      </div>
      <div className={styles.wrapper} data-testid="mobile-wrapper">
        <Icon color={Colors.Emperor} className={styles.deviceIcon}>
          <MobileIcon data-testid="mobile-icon" />
        </Icon>
        {mobile ? enabledIcon : disabledIcon}
      </div>
    </div>
  );
};

export default Devices;
